export default __webpack_public_path__ + "static/media/3.c7b7f723.png";